(function () {
  let sliderInitialized = false;

  /**
   * Add custom JavaScript to the block HTML.
   *
   * @param   Element  block       The block element
   * @param   object   attributes  The block attributes (only available when editing)
   * @return  void
   */
  const initializeBlock = (block, attributes = null) => {
    block.querySelectorAll('.employees__member-button').forEach((button) => {
      let swiper;

      button.addEventListener('click', () => {
        if (!sliderInitialized) {
          swiper = initializeSlider(block);
        }

        swiper.slideTo(button.dataset.index, 0);
        showOverlay(block);
      });
    });

    block.querySelectorAll('.employees__slide-close-button').forEach((button) => {
      button.addEventListener('click', () => {
        hideOverlay(block);
      });
    });

    block.querySelector('.employees__overlay').addEventListener('click', (e) => {
      if (
        e.target.classList.contains('employees__overlay') ||
        e.target.classList.contains('swiper-container') ||
        e.target.classList.contains('swiper-wrapper') ||
        e.target.classList.contains('swiper-slide')
      ) {
        hideOverlay(block);
      }
    });

    window.addEventListener('keydown', (e) => {
      if (e.code === 'Escape') {
        hideOverlay(block);
      }
    });
  };

  const initializeSlider = (block) => {
    return new Swiper(block.querySelector('.employees__slider'), {
      speed: 400,
      slidesPerView: 'auto',
      centeredSlides: true,
      navigation: {
        nextEl: '.employees__slider-nav-button--next',
        prevEl: '.employees__slider-nav-button--prev',
        disabledClass: 'employees__slider-nav-button--disabled',
      },
      keyboard: {
        enabled: true,
      },
      threshold: 3,
    });
  };

  const getOverlay = (block) => {
    return block.querySelector('.employees__overlay');
  };

  const showOverlay = (block) => {
    block.classList.add('employees--overlay-visible');
    getOverlay(block).classList.add('employees__overlay--visible');
  };

  const hideOverlay = (block) => {
    block.classList.remove('employees--overlay-visible');
    getOverlay(block).classList.remove('employees__overlay--visible');
  };

  // Initialize each block on page load (front end)
  document.querySelectorAll('.employees').forEach((block) => {
    initializeBlock(block);
  });

  window.addEventListener('init', () => {
    document.querySelectorAll('.employees').forEach((block) => {
      initializeBlock(block);
    });
  });

  // Initialize the dynamic block preview (editor)
  if (window.acf) {
    window.acf.addAction('render_block_preview/type=employees', ($block, attributes) => {
      initializeBlock($block.find('.employees').get(0), attributes);
    });
  }
})();